import React, { Component } from 'react';
import TextFields from '../UI/TextField-f';
import {withFormik} from "formik/dist/formik";


class SearchForm extends Component {
    render() {
        const { values, handleChange, handleBlur, handleSubmit, col } = this.props;
        return (
            <div className={col ? `col-xs-${col}` : "col-xs-4"}>
                <form onSubmit={ handleSubmit } className="search">
                    <TextFields value={ values.search }
                                onChange={ e => { handleChange(e); this.props.onChange(e.target.value)  } }
                                onBlur={ handleBlur }
                                type="text"
                                hintText="Search"
                                name="search" />

                    <button className="no-style search-btn pointer">
                        <i className="fa fa-search"></i>
                    </button>
                </form>
            </div>
        );
    }
}

const SearchFormWithFormik = withFormik({
    mapPropsToValues({ search }) {
        return {
            search: search || ''
        };
    },
    handleSubmit(searchValue, { props }) {
        props.onSubmit(searchValue.search);
    }
})( SearchForm );

export default SearchFormWithFormik;



// WEBPACK FOOTER //
// ./src/components/UI/SearchForm.js